/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Usage_LabelInputs */

const en_admin_resources_resource_usage_label = /** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is this resource used?`)
};

const de_admin_resources_resource_usage_label = /** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird diese Ressource genutzt?`)
};

const es_admin_resources_resource_usage_label = /** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se utiliza este recurso?`)
};

const fr_admin_resources_resource_usage_label = /** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment cette ressource est-elle utilisée ?`)
};

/** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */
const it_admin_resources_resource_usage_label = en_admin_resources_resource_usage_label;

/** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_usage_label = en_admin_resources_resource_usage_label;

/** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */
const pl_admin_resources_resource_usage_label = en_admin_resources_resource_usage_label;

/** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */
const hu_admin_resources_resource_usage_label = en_admin_resources_resource_usage_label;

/** @type {(inputs: Admin_Resources_Resource_Usage_LabelInputs) => LocalizedString} */
const ro_admin_resources_resource_usage_label = en_admin_resources_resource_usage_label;

/**
* | output |
* | --- |
* | "How is this resource used?" |
*
* @param {Admin_Resources_Resource_Usage_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_usage_label = /** @type {((inputs?: Admin_Resources_Resource_Usage_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Usage_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_usage_label(inputs)
	if (locale === "de") return de_admin_resources_resource_usage_label(inputs)
	if (locale === "es") return es_admin_resources_resource_usage_label(inputs)
	if (locale === "fr") return fr_admin_resources_resource_usage_label(inputs)
	if (locale === "it") return it_admin_resources_resource_usage_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_usage_label(inputs)
	if (locale === "pl") return pl_admin_resources_resource_usage_label(inputs)
	if (locale === "hu") return hu_admin_resources_resource_usage_label(inputs)
	return ro_admin_resources_resource_usage_label(inputs)
});
export { admin_resources_resource_usage_label as "admin.resources.resource_usage_label" }